import { useState } from 'react';
import axios from 'axios';
import { CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export const SubscribeForm = ({ source = 'site', compact = false }) => {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await axios.post(`${API}/subscribe`, { email: email.trim(), source });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Try again.');
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <p className="flex items-center gap-2 text-green-400 text-sm font-semibold" data-testid={`subscribe-success-${source}`}>
        <CheckCircle size={16} /> You're on the list — you'll hear about deals first!
      </p>
    );
  }

  return (
    <form onSubmit={submit} className={compact ? '' : 'max-w-md mx-auto'}>
      <div className="flex gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="flex-1 min-w-0 bg-[#121212] border border-[#27272A] focus:border-[#C41E3A] text-white text-sm px-4 py-3 rounded-sm outline-none transition-colors"
          data-testid={`subscribe-input-${source}`}
        />
        <button
          type="submit"
          disabled={busy}
          className="bg-[#C41E3A] hover:bg-[#A01830] disabled:opacity-50 text-white text-xs font-bold uppercase tracking-wider px-5 rounded-sm transition-all duration-300 whitespace-nowrap"
          data-testid={`subscribe-btn-${source}`}
        >
          {busy ? '...' : 'Sign Up'}
        </button>
      </div>
      {error && <p className="text-[#C41E3A] text-xs mt-2">{error}</p>}
    </form>
  );
};
